(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfc-vault-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-picker]').forEach((picker) => {
    const tabs = [...picker.querySelectorAll('[data-picker-tab]')];
    const selectTab = (tab) => { tabs.forEach((item) => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; const panel = document.getElementById(item.getAttribute('aria-controls')); if (panel) panel.hidden = !active; }); };
    tabs.forEach((tab, index) => { tab.tabIndex = index ? -1 : 0; tab.addEventListener('click', () => selectTab(tab)); tab.addEventListener('keydown', (event) => { if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return; event.preventDefault(); const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]; selectTab(next); next.focus(); }); });
    picker.querySelectorAll('[data-picker-variant]').forEach((input) => input.addEventListener('change', () => { const price = input.closest('form').querySelector('[data-picker-price]'); if (price) price.textContent = input.dataset.price; }));
  });
  document.querySelectorAll('[data-explorer]').forEach((explorer) => {
    const card = explorer.querySelector('[data-card]');
    const content = {
      chip: ['01 / THE TECHNOLOGY', 'A tap opens the door.', 'A compatible phone reads the card and opens your chosen page in seconds.'],
      link: ['02 / COMPATIBILITY', 'Works with compatible phones.', 'Most modern iPhone and Android devices can read NFC cards using their built-in reader.'],
      use: ['03 / QR CODE', 'Another way to connect.', 'Customers can scan the printed QR code with their phone camera when it is set up with your destination.']
    };
    explorer.querySelectorAll('[data-point]').forEach((button) => button.addEventListener('click', () => {
      explorer.querySelectorAll('[data-point]').forEach((item) => item.setAttribute('aria-expanded', String(item === button)));
      const value = content[button.dataset.point];
      explorer.querySelector('[data-info]').hidden = false;
      explorer.querySelector('[data-label]').textContent = value[0];
      explorer.querySelector('[data-title]').textContent = value[1];
      explorer.querySelector('[data-copy]').textContent = value[2];
    }));
    const stage = explorer.querySelector('.vault-explorer__stage');
    if (window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
      window.addEventListener('pointermove', (event) => {
        const x = event.clientX / window.innerWidth - .5;
        const y = event.clientY / window.innerHeight - .5;
        card.style.transform = 'rotateY(' + (x * 24) + 'deg) rotateX(' + (-y * 18) + 'deg)';
      });
      document.addEventListener('pointerleave', () => { card.style.transform = ''; });
    }
    let startX = null;
    card.addEventListener('pointerdown', (event) => { if (event.target.closest('button')) return; startX = event.clientX; card.setPointerCapture(event.pointerId); });
    card.addEventListener('pointermove', (event) => { if (startX !== null) card.style.transform = 'rotateY(' + Math.max(-35, Math.min(35, (event.clientX - startX) / 3)) + 'deg)'; });
    card.addEventListener('pointerup', () => { startX = null; card.style.transform = ''; });
  });

  } catch(e) { console.error(e); }
})();
})();
